// import "./NewRegistration.css";
// import * as React from "react";
// import Box from "@mui/material/Box";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import CorporateDetails from "./CorporateDetails";
// import AdminDetails from "./AdminDetails";
// import InvoiceDetails from "./InvoiceDetails";
// import useHttp from "../../Hooks/use-http";
// import { toast } from "react-toastify";

// const steps = ["Corporate details", "Admin details", "Invoice details"];

// const NewRegistration = () => {
//   const [activeStep, setActiveStep] = React.useState(0);
//   const [isNextClicked, setIsNextClicked] = React.useState(false);
//   const [allData, setAllData] = React.useState({});

//   const { isLoading, sendRequest } = useHttp();

//   React.useEffect(() => {
//     if (activeStep === 3) {
//       sendRequest(
//         {
//           url: "/addupdatecorporate",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               mobileNumber: allData.adminDetails.adminMoNumber,
//               // adminEmail: allData.adminDetails.adminEmail,
//               imageID: allData.adminDetails.adminPhoto,
//               name: allData.adminDetails.adminName,
//               contractEndDate: allData.cpDetails.contractEndDate,
//               contractStartDate: allData.cpDetails.contractStartDate,
//               corporateID: "",
//               corporateLatLong: allData.cpDetails.cpLatLng,
//               corporateLogo: allData.cpDetails.cpLogo,
//               corporatename: allData.cpDetails.cpName,
//               address: allData.cpDetails.cpAddress,
//               corporateType: "",
//               country: allData.cpDetails.country,
//               creditPeriod: allData.cpDetails.creditPeriod,
//               emailID: allData.adminDetails.adminEmail,
//               enabledModule: allData.cpDetails.enabledModules.join(),
//               invoiceContactEmail: allData.invoiceDetails.invoiceEmail,
//               invoiceContactName: allData.invoiceDetails.invoiceName,
//               accountManagerID: allData.cpDetails.accountManager?.toString() || "",
//               // newRecord: 1,
//               password: allData.adminDetails.adminMoNumber,
//               // roleID: localStorage.getItem("roleId"),
//               roleID: "2",
//               salesExecutive: allData.cpDetails.salesExecutive,
//               shuttleFor: allData.cpDetails.shuttleType.join(),
//             },
//             // accountManagerID: "222",
//           },
//         },
//         corporateRegResponse
//       );
//     }
//   }, [activeStep]);

//   const corporateRegResponse = (data) => {
//     // console.log(data);
//     if(data?.status == "200" || data?.status == "201"){
//       toast.success("Corporate created successfully!")
//     }else{
//       toast.error("Some thing is wrong!")
//     }
//   };

//   const handleNext = () => {
//     setIsNextClicked(true);
//     // setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };

//   return (
//     <div className="corp-reg-container">
//       <h3 style={{ padding: "10px 0 0 10px" }}>Corporate Registration</h3>
//       <div className="corp-reg-sub-container">
//         <Box sx={{ width: "100%", height: "100%" }}>
//           <Stepper activeStep={activeStep} alternativeLabel>
//             {steps.map((label, index) => {
//               const stepProps = {};
//               const labelProps = {};
//               return (
//                 <Step key={label} {...stepProps}>
//                   <StepLabel {...labelProps}>{label}</StepLabel>
//                 </Step>
//               );
//             })}
//           </Stepper>
//           {activeStep === steps.length ? (
//             <React.Fragment>
//               <Typography sx={{ mt: 2, mb: 1 }}>
//                 All steps completed - you&apos;re finished
//               </Typography>
//             </React.Fragment>
//           ) : (
//             <React.Fragment>
//               {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "30px",
//                   alignItems: "center",
//                   justifyContent: "flex-start",
//                   flexWrap: "wrap",
//                   width: "100%",
//                   margin: "0 40px",
//                   padding: "10px",
//                   height: "70%",
//                 }}
//               >
//                 {activeStep === 0 && (
//                   <CorporateDetails
//                     setActiveStep={setActiveStep}
//                     setAllData={setAllData}
//                     allData={allData}
//                     isNextClicked={isNextClicked}
//                     setIsNextClicked={setIsNextClicked}
//                   />
//                 )}
//                 {activeStep === 1 && (
//                   <AdminDetails
//                     setActiveStep={setActiveStep}
//                     setAllData={setAllData}
//                     allData={allData}
//                     isNextClicked={isNextClicked}
//                     setIsNextClicked={setIsNextClicked}
//                   />
//                 )}
//                 {activeStep === 2 && (
//                   <InvoiceDetails
//                     setActiveStep={setActiveStep}
//                     setAllData={setAllData}
//                     allData={allData}
//                     isNextClicked={isNextClicked}
//                     setIsNextClicked={setIsNextClicked}
//                   />
//                 )}
//               </div>
//               <div style={{ margin: "20px 40px" }}>
//                 <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
//                   <Button
//                     color="inherit"
//                     disabled={activeStep === 0}
//                     onClick={handleBack}
//                     sx={{ mr: 1, fontSize: "16px" }}
//                   >
//                     Back
//                   </Button>
//                   <Box sx={{ flex: "1 1 auto" }} />
//                   <Button onClick={handleNext} sx={{ fontSize: "16px" }}>
//                     {activeStep === steps.length - 1 ? "Finish" : "Next"}
//                   </Button>
//                 </Box>
//               </div>
//             </React.Fragment>
//           )}
//         </Box>
//       </div>
//     </div>
//   );
// };

// export default NewRegistration;

import "./NewRegistration.css";
import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CorporateDetails from "./CorporateDetails";
import AdminDetails from "./AdminDetails";
import InvoiceDetails from "./InvoiceDetails";
import useHttp from "../../Hooks/use-http";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import { useNavigate } from "react-router-dom";

const steps = ["Corporate details", "Admin details", "Invoice details"];

const NewRegistration = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [isNextClicked, setIsNextClicked] = React.useState(false);
  const [allData, setAllData] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const navigate = useHistory();

  const { isLoading, sendRequest } = useHttp();

  React.useEffect(() => {
    if (activeStep === 3 && !isSubmitting) {
      setIsSubmitting(true);
      sendRequest(
        {
          url: "/addupdatecorporate",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              // mobileNumber: allData.adminDetails.adminMoNumber,
              mobileNumber: `${allData.adminDetails.adminCountryCode}${allData.adminDetails.adminMoNumber}`,
              imageID: allData.adminDetails.adminPhoto,
              name: allData.adminDetails.adminName,
              contractEndDate: allData.cpDetails.contractEndDate,
              contractStartDate: allData.cpDetails.contractStartDate,
              corporateID: "",
              corporateLatLong: allData.cpDetails.cpLatLng,
              corporateLogo: allData.cpDetails.cpLogo,
              corporatename: allData.cpDetails.cpName,
              address: allData.cpDetails.cpAddress,
              corporateType: "",
              country: allData.cpDetails.country,
              creditPeriod: allData.cpDetails.creditPeriod,
              emailID: allData.adminDetails.adminEmail,
              enabledModule: allData.cpDetails.enabledModules.join(),
              invoiceContactEmail: allData.invoiceDetails.invoiceEmail,
              invoiceContactName: allData.invoiceDetails.invoiceName,
              accountManagerID:
                allData.cpDetails.accountManager?.toString() || "",
              roleID: "2",
              password: allData.adminDetails.adminMoNumber,
              salesExecutive: allData.cpDetails.salesExecutive,
              shuttleFor: allData.cpDetails.shuttleType.join(),
            },
          },
        },
        corporateRegResponse
      );
    }
  }, [activeStep]);

  const corporateRegResponse = (data) => {
    setIsSubmitting(false);
    if (data?.status == "200" || data?.status == "201") {
      toast.success("Corporate created successfully!");
      navigate.push("/corporates");
    } else {
      toast.error("Something went wrong!");
      setActiveStep(2);
    }
  };

  const handleNext = () => {
    setIsNextClicked(true);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div className="corp-reg-container">
      <h3 style={{ padding: "10px 0 0 10px" }}>Corporate Registration</h3>
      <div className="corp-reg-sub-container">
        <Box sx={{ width: "100%", height: "100%" }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  flexWrap: "wrap",
                  width: "100%",
                  margin: "0 40px",
                  padding: "10px",
                  height: "70%",
                }}
              >
                {activeStep === 0 && (
                  <CorporateDetails
                    setActiveStep={setActiveStep}
                    setAllData={setAllData}
                    allData={allData}
                    isNextClicked={isNextClicked}
                    setIsNextClicked={setIsNextClicked}
                  />
                )}
                {activeStep === 1 && (
                  <AdminDetails
                    setActiveStep={setActiveStep}
                    setAllData={setAllData}
                    allData={allData}
                    isNextClicked={isNextClicked}
                    setIsNextClicked={setIsNextClicked}
                  />
                )}
                {activeStep === 2 && (
                  <InvoiceDetails
                    setActiveStep={setActiveStep}
                    setAllData={setAllData}
                    allData={allData}
                    isNextClicked={isNextClicked}
                    setIsNextClicked={setIsNextClicked}
                  />
                )}
              </div>
              <div style={{ margin: "20px 40px" }}>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1, fontSize: "16px" }}
                  >
                    Back
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button
                    onClick={handleNext}
                    sx={{ fontSize: "16px" }}
                    disabled={isSubmitting}
                  >
                    {activeStep === steps.length - 1 ? "Finish" : "Next"}
                  </Button>
                </Box>
              </div>
            </React.Fragment>
          )}
        </Box>
      </div>
    </div>
  );
};

export default NewRegistration;
